import React from 'react'
import styled from 'styled-components'
import BasicText from '../../basic/BasicText';
import { ContentWrap, InputWrap, ItemWrap } from '../../../style/basic/commonStyle';
import { PAYER_TYPE_VAL, RELATION_VAl } from '../../applicationForm/data/dummy';

export default function MyPagePaymentPart({info}:any) {
    return (
        <Wrap>
            <BasicText fontWeight={700} fontSize={18}>납부자 정보</BasicText>
            <ContentWrap mt={20}>
                <ItemWrap>
                    <BasicText>납부자와의 관계</BasicText>
                    <InputWrap>
                        <BasicText>{RELATION_VAl[info?.order_payment?.order_payment_relation ?? '1']}</BasicText>
                    </InputWrap>
                </ItemWrap>
                <ItemWrap>
                    <BasicText>납부 정보</BasicText>
                    <InputWrap>
                        <BasicText>{PAYER_TYPE_VAL[info?.order_payment?.order_payment_method ?? '1']}</BasicText>
                    </InputWrap>
                </ItemWrap>
                <ItemWrap>
                    <BasicText>납부자 명</BasicText>
                    <InputWrap>
                        <BasicText>{info?.order_payment?.order_payment_name}</BasicText>
                    </InputWrap>
                </ItemWrap>
                <ItemWrap>
                    <BasicText>주민등록번호</BasicText>
                    <InputWrap>
                        <BasicText>{info?.order_payment?.order_payment_resident_number}</BasicText>
                    </InputWrap>
                </ItemWrap>
                <ItemWrap>
                    <BasicText>계좌번호</BasicText>
                    <InputWrap>
                        <BasicText>{info?.order_payment?.order_payment_bank_name} / {info?.order_payment?.order_payment_account_number}</BasicText>
                    </InputWrap>
                </ItemWrap>
            </ContentWrap>
          
        </Wrap>
    )
}

const Wrap = styled.div`
    width: 100%;
`;